import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

export interface Props {
  id: string
  children: () => ReactElement
  onSuccess: () => void
}

const DeleteCustomScriptRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/custom_scripts/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteCustomScriptRequest
